<script setup lang="ts">
import MultiStepsLogin from "@/components/auth/MultiStepsLogin.vue";
import ComplianceDialog from "@/components/ComplianceDialog.vue";
import { useAuthStore } from "@/stores/authStore";
import { useConfigStore } from "@/stores/configStore";
import { storeToRefs } from "pinia";
import { computed } from "vue";

const authStore = useAuthStore();
const { showComplianceDialog } = storeToRefs(authStore);
const configStore = useConfigStore();

const isTycEnabled = computed(() => configStore.tycEnabled);
</script>

<template>
  <div class="h-full">
    <MultiStepsLogin />
    <ComplianceDialog
      v-if="isTycEnabled && showComplianceDialog"
      @close="() => (authStore.showComplianceDialog = false)"
    />
  </div>
</template>
